var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoldDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14798 9.39842C8.84329 9.70273 8.43027 9.87365 7.99965 9.87365C7.56902 9.87365 7.156 9.70273 6.85131 9.39842L0.721815 3.27108C0.417114 2.96624 0.245992 2.55284 0.246094 2.12182C0.246195 1.69081 0.417512 1.27749 0.722356 0.972792C1.0272 0.668091 1.4406 0.496969 1.87161 0.49707C2.30263 0.497172 2.71595 0.668489 3.02065 0.973333L7.99965 5.95233L12.9786 0.973333C13.285 0.677179 13.6954 0.513192 14.1215 0.516692C14.5475 0.520192 14.9552 0.690899 15.2566 0.992046C15.5581 1.29319 15.7291 1.70069 15.733 2.12675C15.7369 2.55282 15.5733 2.96338 15.2775 3.27L9.14906 9.3995L9.14798 9.39842Z",
    fill: "#505050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldDownArrow);
export default __webpack_public_path__ + "static/media/bold-down-arrow.77389907eb91cf0158ae6eb050f0dce1.svg";
export { ForwardRef as ReactComponent };